// Module
var code = "<ngx-loading-bar></ngx-loading-bar> <ng-kits-header></ng-kits-header> <router-outlet></router-outlet> <footer class=\"text-center\"> <p>&copy; {{ currentYear }} KITS</p> </footer> ";
// Exports
export default code;